/*eslint no-undef: 0*/

import { fromJS } from 'immutable';
import Segment from '../../helpers/segment';
import { CreateAccountActionTypes } from './actions';
import { createReducer } from '../../helpers/store';

const initialState = fromJS({
  showModal: false,
  errors: '',
  isNew: false
});

/**
 * Called when create account request is initiated.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleCreateAccountRequest = (state, action) => {
  return state.set('errors', '');
};

/**
 * Called when the create account request fails.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleCreateAccountFailure = (state, action) => {
  Segment.track('Failed Account Creation', { error: action.error.data });
  return state.set(
    'errors',
    action.error.data.email || 'Sorry, we were unable to create your account.'
  );
};

/**
 * Called when create account request is successful.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */
export const handleCreateAccountSuccess = (state, action) => {
  Segment.track('Created Account');
  return state
    .set('errors', '')
    .set('showModal', false)
    .set('isNew', true);
};

export const handleCompleteAccount = (state, action) => {
  Segment.track('Completed Account');
  return state.set('isNew', false);
};

export const handleShowCreateAccountModal = (state, action) => {
  return state.set('showModal', action.show);
};

export const createAccountReducer = createReducer(initialState, {
  [CreateAccountActionTypes.CREATE_ACCOUNT_REQUEST]: handleCreateAccountRequest,
  [CreateAccountActionTypes.CREATE_ACCOUNT_SUCCESS]: handleCreateAccountSuccess,
  [CreateAccountActionTypes.CREATE_ACCOUNT_FAILURE]: handleCreateAccountFailure,
  [CreateAccountActionTypes.COMPLETE_ACCOUNT]: handleCompleteAccount,
  [CreateAccountActionTypes.SHOW_CREATE_ACCOUNT_MODAL]: handleShowCreateAccountModal
});



/** WEBPACK FOOTER **
 ** ./src/state/create-account/reducer.js
 **/